import { getPodPrice } from './utils';

const membershipDiscountRate =
  window.gon.membership_discount_rate ||
  1.0 /
    (1.0 +
      window.gon.eligible_subscription_plan_params[
        'subscribable_variant_free_frequency'
      ]);
const initialState = {
  membershipDiscountRate,
  podPackPrice: getPodPrice(window.gon.products),
};

export default initialState;



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/initialState.js